import type { AppId } from '@inno-tools/container-bridge'
import type { ShortcutGroup } from 'shared/types/desktop-grid'

/** Stable identifier for the system-provided Office Tools group. */
export const OFFICE_TOOLS_GROUP_ID = 'shortcut-group-office-tools'

/** The five default shortcuts owned by the Office Tools system group. */
export const OFFICE_TOOLS_APP_IDS: AppId[] = [
  'cluster-files' as AppId,
  'cluster-pdf' as AppId,
  'cluster-docs' as AppId,
  'cluster-cells' as AppId,
  'cluster-slides' as AppId
]

export type ShortcutGroupCapabilities = {
  canMove: boolean
  canRename: boolean
  canDelete: boolean
  canAcceptMembers: boolean
  canRemoveMembers: boolean
  canMoveMembers: boolean
}

const USER_GROUP_CAPABILITIES: ShortcutGroupCapabilities = {
  canMove: true,
  canRename: true,
  canDelete: true,
  canAcceptMembers: true,
  canRemoveMembers: true,
  canMoveMembers: true
}

const OFFICE_TOOLS_GROUP_CAPABILITIES: ShortcutGroupCapabilities = {
  canMove: true,
  canRename: false,
  canDelete: false,
  canAcceptMembers: false,
  canRemoveMembers: false,
  canMoveMembers: false
}

type GroupIdentity =
  | Pick<ShortcutGroup, 'id' | 'kind'>
  | string
  | null
  | undefined

/** Supports both new typed groups and groups persisted before `kind` existed. */
export const isOfficeToolsGroup = (group: GroupIdentity): boolean =>
  typeof group === 'string'
    ? group === OFFICE_TOOLS_GROUP_ID
    : group?.kind === 'office-tools' || group?.id === OFFICE_TOOLS_GROUP_ID

export const getShortcutGroupCapabilities = (
  group: GroupIdentity
): ShortcutGroupCapabilities =>
  isOfficeToolsGroup(group)
    ? OFFICE_TOOLS_GROUP_CAPABILITIES
    : USER_GROUP_CAPABILITIES

export const isShortcutMemberLocked = (
  groups: ShortcutGroup[],
  itemId: string
): boolean =>
  groups.some(
    group =>
      group.memberIds.includes(itemId) &&
      !getShortcutGroupCapabilities(group).canMoveMembers
  )
